import { scan } from "@pdfking/rfunc"
import { IsNull, Values } from "@pdfking/tfunc"
export function url_parse(url: string) {
  var parser = document.createElement("a")
  parser.href = url

  // sample usage

  //parser.protocol // => "http:"
  //parser.hostname // => "example.com"
  //parser.port     // => "3000"
  //parser.pathname // => "/pathname/"
  //parser.search   // => "?search=test"
  //parser.hash     // => "#hash"
  //parser.host     // => "example.com:3000"

  return parser
}
export function url_decode(s: string) {
  try {
    return decodeURIComponent(s).replace(/\r\n|\r|\n/g, "\r\n")
  } catch (_e) {
    return ""
  }
}
export function url_encode(s: string | number | null | undefined) {
  if (IsNull(s)) {
    return ""
  }
  return encodeURIComponent(s)
}
export function url_query_decode(qs: string | undefined) {
  var multimap: Record<string, string> = {}
  if (!qs) return multimap
  if (qs.length > 1) {
    qs.replace(/\+/g, "%20").replace(
      /([^=&]+)=([^&]*)/g,
      (_match: string, hfname: string, hfvalue: string) => {
        multimap[url_decode(hfname)] = url_decode(hfvalue)
        return ""
      }
    )
  }
  return multimap
}
type UrlValue = string | number | (string | number)[]
export function url_query_encode(array: Record<string, UrlValue>): string {
  const mapping: string[] = []
  scan(
    (values: string | string[], key) =>
      scan(
        value => mapping.push(`${url_encode(key)}=${url_encode(value)}`),
        values
      ),
    array
  )
  return Values(mapping).join("&")
}
export function add_get_param(
  href: string,
  extra_params: Record<string, string | null>
): string {
  var params = url_query_decode(href.split("?")[1])
  scan((value, key) => {
    if (value) {
      params[key] = value
    } else {
      delete params[key]
    }
  }, extra_params)
  var url = href.split("?")[0]
  var extra = url_query_encode(params)
  if (extra) url += `?${extra}`
  extra = href.split("#")[1]
  if (extra) url += `#${extra}`
  return url
}

export function make_absolute_url(path: string) {
  return new URL(path, window.location.origin).href
}
